<template>
    <h1>
        Sinochemitech PMS
    </h1>
</template>

<script>
    import {Toast} from 'vant';
    import userInfo from "../../store/userInfo";

    export default {
        store: userInfo,
        mounted() {
            userInfo.commit('showNavBar');
            userInfo.commit('setNavTitle',"客户列表");
            console.log(userInfo);

            setTimeout(function () {
                if (typeof uexWindow !== "undefined") {
                    uexWindow.evaluateScript("", '0', "loadingMsg.HideMsg();");
                }
            }, 100);
            let token = this.$route.query.token;
            if (token == null) {
                Toast.fail('Token is required.');
                return;
            }
            localStorage.setItem('sinochemtoken', token);
            this.$router.push("/app/customer");
        }
    };
</script>
